import Code from "../../../components/code";
import DocsAuthor from "../../components/docsAuthor";

export const dependencyManagementPage = {
    title: "Dependency Management",
    sections: [
        {
            id: "addingDependencies",
            name: "Adding Dependencies",
        },
        {
            id: "removingDependencies",
            name: "Removing Dependencies",
        },
        {
            id: "installingDependencies",
            name: "Installing All Dependencies",
        },
    ],
    content: (
        <>
        <DocsAuthor nickname="StrayVibes" publishedAt="June 1, 2025 at 11:20 AM" />
            <section id="addPackages">
                <h2>➕ Adding Packages - Grow Your Project!</h2>
                <p>
                    Bring new functionality into your project with ease! Use <Code fullWidth>meow add &lt;pkg1...pkgN&gt; [-g] [--dev]</Code> to add one or more packages.
                    Whether you need a global tool 🌐 (with the <code>-g</code> flag) or a specific development dependency 🛠️ (with <code>--dev</code>), Neko-CLI makes integration seamless.
                </p>
            </section>
            <section id="removePackages">
                <h2>🗑️ Removing Packages - Keep It Clean!</h2>
                <p>
                    Time to declutter your project? 🧹 Easily remove unneeded packages with <Code fullWidth>meow remove &lt;pkg1...pkgN&gt; [-g] [--dev]</Code>.
                    This command helps you maintain a lean and efficient codebase, whether you're tidying up global installations or specific development clutter. ✨
                </p>
            </section>
            <section id="installAll">
                <h2>⬇️ Installing All Dependencies - Get Ready to Run!</h2>
                <p>
                    Got a new project or just pulled the latest changes? 🚀 Get everything set up instantly! Both <Code fullWidth>meow meow</Code> and <Code fullWidth>meow all</Code> commands will install all dependencies specified in your project's configuration.
                    It’s the quickest way to get your project up and running! 🐈
                </p>
            </section>
        </>
    ),
};
